import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import type {TicketingPillProps} from './ticketing-pill.types';
import styles from './ticketing-pill.module.scss';

export function TicketingPill({icon, label}: TicketingPillProps): ReactElement {
  return (
    <div className={`${styles.pill} gap-1 bg-neutral-0 flex-row-align-center corner-radius-full`}>
      <Icon className="ct-neutral-primary" icon={icon} size={IconSize.SIZE_ICON_12} />
      <Text className="ct-neutral-primary" val={label} size={TextSize.SM} bold />
    </div>
  );
}
